export const TWO_FACTOR_STATUSES = {
    ENABLED: {
        key: 'ENABLED',
        translateKey: 'auth.two_fa_status.enabled',
        class: '',
    },
    ENABLING: {
        key: 'ENABLING',
        translateKey: 'auth.two_fa_status.enabling',
        class: '',
    },
    DISABLED: {
        key: 'DISABLED',
        translateKey: 'auth.two_fa_status.disabled',
        class: '',
    },
    DISABLING: {
        key: 'DISABLING',
        translateKey: 'auth.two_fa_status.disabling',
        class: '',
    },
};

export const LOGIN_MESSAGE = {
    TWO_FACTOR_AUTH_ENABLED: 'TWO_FACTOR_AUTH_ENABLED',
    SUCCESS: 'SUCCESS',
    FORCE_PASSWORD_CHANGE: 'FORCE_PASSWORD_CHANGE',
    SUGGEST_ENABLE_2FA: 'SUGGEST_ENABLE_2FA',
};
